<section class="pt-4">
  <!-- <h2 class="text-left text-white px-5 mt-5">
    Crear etapa proyecto {{ summaryInfoDto.title }}
  </h2> -->

  <div class="row pb-4">
    <div class="col-12 d-flex justify-content-between align-items-center px-5">
      <h2 class="text-left text-white px-3 my-4">
        Crear etapa proyecto {{ summaryInfoDto.title }}
      </h2>

      <div class="mx-3">
        <button
          class="badge rounded-pill btn btn-outline-light mx-2 d-flex align-items-center"
          [routerLink]="['/pdg/project', idProject, 'stages']"
        >
          <i
            class="fa-solid fa-right-from-bracket m-2 fs-6"
            aria-hidden="true"
          ></i>
          <span class="m-2 fs-6">Volver al listado</span>
        </button>


      </div>
    </div>
  </div>

  <div class="container-fluid px-5">
    <br />
    <div class="row backgroundTable card">
      <div class="card-header">
        <h6 class="text-white p-2">Formulario para crear etapas</h6>
      </div>
      <div
        class="col-12 componente-importantes componente-importantes-from-popup p-3"
      >
        <form
          action=""
          method="post"
          (submit)="formSubmit()"
          [formGroup]="createProjectStageForm"
        >
          <div class="col-12 p-3">
            <div class="form-group">
              <div class="d-flex justify-content-start mb-2">
                <label for="stagesId" class="text-white">Nombre etapa</label>
              </div>
              <select
                required
                class="custom-outline-input form-control"
                formControlName="stagesId"
                id="stagesId"
              >
                <option selected value="">Seleccione una dependencia</option>
                <option *ngFor="let item of listStage" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="state" class="text-white">Estado</label>
              </div>
              <select
                required
                class="custom-outline-input form-control"
                id="state"
                formControlName="state"
              >
                <option selected value="">Seleccione un estado</option>
                <option *ngFor="let item of listStado" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="startDate" class="text-white"
                  >Fecha de inicio</label
                >
              </div>
              <input
                type="date"
                required
                class="custom-outline-input date form-control"
                id="startDate"
                name="startDate"
                placeholder="Fecha de inicio"
                formControlName="startDate"
              />
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="endDate" class="text-white">Fecha de termino</label>
              </div>
              <input
                type="date"
                required
                class="date custom-outline-input form-control"
                id="endDate"
                name="endDate"
                placeholder="Fecha de finalizacion"
                formControlName="endDate"
              />
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-3 mb-2">
                <label for="dependenceId" class="text-white">Dependencia</label>
              </div>

              <select
                required
                class="custom-outline-input form-control"
                id="dependenceId"
                formControlName="dependenceId"
              >
                <option selected value="">Seleccione una dependencia</option>
                <option *ngFor="let item of listProjectStage" [value]="item.id">
                  {{ item.name }} - {{ item.startDate }} / {{ item.endDate }}
                </option>
              </select>
            </div>
            <br />
            <div class="">
              <div class="d-flex justify-content-end">
                <button class="mx-2 btn btn-outline-light">
                  <i class="fa fa-floppy-disk" aria-hidden="true"></i> Guardar
                  datos
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
